<template>
  <div class="swap">
    <div class="swap-top">
      <div class="swap-top__name">换货单</div>
    </div>
    <div class="swap-table">
      <Table :head="swapOrderTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { OrderNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'swapOrder',
  components: {
    Table
  },
  data(){
    return {
      swapOrderTableHead: OrderNewModule.NEWSWAPORDERTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.swap{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
  }
}
</style>
